import { AbstractPmsApiService } from "./abstract.service";
import { SmsRate, SystemConfiguration } from "../models";

/**
 * @class SmsRatePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SmsRate>}
 */
export class SmsRatePmsApiService extends AbstractPmsApiService {

    /**
     * @propertyType {string}
     * @protected
     */
    get urlPattern() {

        return '/sms-rate(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SmsRate}
     * @protected
     */
    newModel(attributes) {

        return new SmsRate(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<SmsRate>>}
     */
    get (params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsRate} smsRate
     * @returns {Promise.<SmsRate>}
     */
    create(smsRate) {

        const url = this.url();

        return this.http
            .post(url, smsRate, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Integer} id
     * @param {Object} params
     */
    show(id, params = {}) {

        const url = this.url({
            id: id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsRate} smsRate
     * @returns {Promise.<SmsRate>}
     */
    update(smsRate) {

        const url = this.url({id: smsRate.id});

        return this.http
            .put(url, smsRate, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsRate} smsRate
     * @returns {Promise.<boolean>}
     */
    delete(smsRate) {

        const url = this.url({id: smsRate.id});

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    getBaseRate() {

        const url = this.url();

        return this.http
            .get(url + '/base', {
                headers: this.authHeaders
            })
            .then((response) => new SystemConfiguration(this.extractData(response)))
            .catch(this.getErrorHandler());
    }

    saveBaseRate(rate) {

        const url = this.url();

        return this.http
            .put(url + '/base', rate, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms-rate.service.js